import React from 'react';
import { Link, Route, Routes, useParams, useLocation } from 'react-router-dom';
import Feature from '../../Feature';
import { getOne } from './../../../common/v4/BackendProvider'
import { useState, useEffect } from 'react';
const cx = require('classnames');
var imm = require('immutable');

const CarrierWrapper = (props) => {
    const { carrier_id } = useParams();
    const [data, setData] = useState(imm.Map());
    const [revert, setRevert] = useState(imm.Map());
    const [metadata, setMetadata] = useState([]);
    const [routes, setRoutes] = useState([
        {url: 'edit', name: 'Main'},
        {url: 'voiceaccounts', name: 'Voice Accounts', feature: 'voice-wholesale'},
        {url: 'summary', name: 'Summary'},
        {url: 'billing', name: 'Billing'},
        {url: 'smppaccounts', name: 'SMPP Accounts', feature: 'sms-wholesale'},     
    ])

    useEffect(() => {
        loadFromServer();
    }, []);
  
    const loadFromServer = () => {
        getOne('/admin/carriers/carriers/', carrier_id).then(
            response => {
                setData(imm.Map(response.data.data))
                setRevert(imm.Map(response.data.data))
                setMetadata(response.data.metadata)
            }
        );
    }
    
    return(
            <div>
                <div className="row">
                    <div className="col-md-12">
                        <h4>Interconnect { data.get("ATRNAME") }</h4>
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-12">
                        <FixedCarrierAccountMenu
                            carrier_id={ props.carrier_id }
                            routes = {routes}
                            pathname = {props.pathname}
                        />
                     </div>
                </div>
            </div>
        )
};


const FixedCarrierAccountMenu = (props) => {
    const { carrier_id } = useParams();
    const { pathname } = useLocation();
    return(
        <ul className="nav nav-tabs">
            {
                props.routes.map(function (row, i) {
                    var location = '/carriers/carriers/' + carrier_id + '/' + row.url;
                    return (
                        row.feature ? (
                            <Feature name={row.feature} key={i}>
                                <li key={i} className={cx(location == pathname ? "active" : "")}>
                                    <Link exact={true} to={ location }>{row.name}</Link>
                                </li>
                            </Feature>
                        ) : (
                            <li key={i}  className={cx(location == pathname ? "active" : "")}>
                                <Link exact={true} to={ location }>{row.name}</Link>
                            </li>
                        )
                    )
                }, this)
            }
        </ul>
    )
}

export default class extends React.Component {
    render() {

        const carrier_id = this.props.match?.params.carrier_id;
        var urlattrs = {carrier_id : carrier_id};
        return (
            <div>
                <CarrierWrapper urlattrs={this.props.urlattrs} carrier_id={carrier_id} pathname={this.props.location?.pathname}/>
                <Routes>
                    {/* <Route index element={<CarrierMain childProps={this.props.childProps}/>} /> */}
                    {this.props.routes?.map((route, i) => (                        
                        <Route 
                            key={i} 
                            path={route.path} 
                            element={<route.component routes={route.routes} childProps={this.props.childProps}/>}
                        />
                    ))}
                </Routes>
            </div>
        )
    }
}